import {Layout} from "antd";
import React from "react";
import {Outlet, useLocation} from "react-router-dom";
import {useRecoilValue} from "recoil";
import {Sider_4} from "./component/sider";
import {Breadcrumb_4} from "./component/breadcrumb";
import {Footer_4} from "./component/footer";
import {globalColorThemeState} from "../../_common/global_state";
import "./css/style.css";

const Layout_4 = ({routes, registerField}) => {
    const location = useLocation();

    const colorState = useRecoilValue(globalColorThemeState);

    const themeClass = colorState === "dark" ? "dark-theme" : "light-theme";

    return (
        <Layout id={"layout-4"} className={themeClass}>
            <Layout>
                <Sider_4 routes={routes} registerField={registerField}/>
                <Layout id={"layout-body-4"}>
                    <Layout className={"layout_padding container-xxl"}>
                        {location.pathname !== "/dashboard" && <Breadcrumb_4/>}
                        <Outlet/>
                    </Layout>
                </Layout>
            </Layout>
            <Footer_4/>
        </Layout>
    );
};
export default Layout_4;
